var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26ZM15 20V22H17V20H15ZM16.77 15.822C15.6461 16.4808 14.9684 17.6976 15 19H17C17.0847 18.0328 17.6177 17.1612 18.44 16.645C19.3497 16.0602 19.9284 15.079 20 14C20.0161 12.5709 19.2685 11.2418 18.039 10.5134C16.8094 9.78491 15.2846 9.76776 14.039 10.4684C12.7933 11.169 12.0161 12.4809 12 13.91V14H14C14 12.8954 14.8954 12 16 12C17.1046 12 18 12.8954 18 14C18 14.879 17.4313 15.315 16.7722 15.8202L16.77 15.822Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.f435b234482c6903e6a873bdbc6c6a58.svg";
export { ForwardRef as ReactComponent };